var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#333",
  strokeWidth: 1.25,
  clipPath: "url(#send-email_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m13.313 29.28 9.548 9.55a.5.5 0 0 0 .754-.055L45.12 10.043a.5.5 0 0 0-.504-.79L3.152 18.028a.5.5 0 0 0-.25.843l8.198 8.198"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M44.289 9.92 13.313 29.28M44.289 9.92 11.1 27.069"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m11.1 27.068.696 11.616 1.517-9.403"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.796 38.684 4.062-3.595 1.015-.899.508-.45"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "send-email_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 48V0h48v48z"
})))));
export { SvgSendEmail as ReactComponent };